import { useTranslation } from 'react-i18next';

import type { CreditNote } from '~/api/creditNotes/types';

import { useDownloadCreditNoteFcFiles } from '~/api/creditNotes';
import { HttpNotFoundError } from '~/api/errors';
import { Button, Menu } from '~/components';
import { optionsMenuTriggerStyle } from '~/components/Table/TableRow.css';
import { toast } from '~/utils/toast';

type Props = {
  creditNote: CreditNote;
};

export const CreditNoteOptionsCell = ({ creditNote }: Props) => {
  const downloadMutation = useDownloadCreditNoteFcFiles();

  const { t } = useTranslation(['common', 'creditnotes']);

  if (creditNote.status !== 'Approved') return null;

  return (
    <Menu.Root>
      <Menu.Trigger render={<Button aria-label={t('common:actions.openMenu')} className={optionsMenuTriggerStyle} icon="MoreVert" />} />

      <Menu.List>
        <Menu.Item
          disabled={downloadMutation.isPending}
          icon="Download"
          onClick={() =>
            downloadMutation.mutate(
              { ids: [creditNote.id] },
              {
                onError: (error) =>
                  toast.danger({
                    description:
                      error instanceof HttpNotFoundError ? t('creditnotes:alerts.missingFcFiles', { count: 1 }) : t('common:error'),
                  }),
              },
            )
          }
        >
          {t('creditnotes:overview.rowActions.download')}
        </Menu.Item>
      </Menu.List>
    </Menu.Root>
  );
};
